import { SHADOW_PLACEMENT_TO_BOX_SHADOW_MAP } from '../const';
import type { ShadowPlacement } from '../types';

const getSingleBoxShadow = (shadowPlacement: ShadowPlacement): string =>
  SHADOW_PLACEMENT_TO_BOX_SHADOW_MAP[shadowPlacement];

export const getBoxShadow = (
  shadowPlacementProp: ShadowPlacement | ShadowPlacement[],
): string => {
  if (Array.isArray(shadowPlacementProp)) {
    const boxShadowsArray = shadowPlacementProp.map(getSingleBoxShadow);

    const boxShadow = boxShadowsArray.join(', ');

    return boxShadow;
  }

  const boxShadow = getSingleBoxShadow(shadowPlacementProp);

  return boxShadow;
};
